var _baseUrl = process.env.VUE_APP_ENDPOINT;

export let baseUrl = _baseUrl;